module.exports = __webpack_public_path__ + "img/logo_v.5c66f868.svg";